import React from "react";
import { Link } from 'react-router-dom'

const  DeviceList = (props) => {
  const {devList} = props
  if (devList.length === 0) return <></>


  return (
    <>
    
    <DataTable data={devList} />

    </>
  )
}

export default  DeviceList
//{{ pathname: '/selected_device/33' }}
//<Link to='/selected_device'>selected_device</Link>

const DataTable = ({ data }) => {
  if (!data || data.length === 0) {
      return <p>No data available</p>;
  }

  return (
    <div className="container mt-5">
    <h2>Device List</h2>
    <table className="table table-striped">
        <thead>
            <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Description</th>
                <th>Data Created</th>
            </tr>
        </thead>
        <tbody>
            {data.map((item) => (
                <tr key={item.id}>
                    <td><Link to={`/selected_device/${item.id}`}>#{item.id}</Link></td>
                    <td>{item.name}</td>
                    <td>{item.description !== null ? item.description : '-'}</td>
                    <td>{new Date(item.date_created).toLocaleString()}</td>
                </tr>
            ))}
        </tbody>
    </table>
</div>
  );
};